import { useState, useEffect } from 'react';

const STORAGE_KEY = 'site_unlocked';
const SITE_PASSWORD = import.meta.env.VITE_SITE_PASSWORD;

export function PasswordGate({ children }: { children: React.ReactNode }) {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // If no password is configured, skip the gate entirely
    if (!SITE_PASSWORD) {
      setIsUnlocked(true);
      setIsChecking(false);
      return;
    }

    // Check if already unlocked
    const unlocked = localStorage.getItem(STORAGE_KEY);
    if (unlocked === 'true') {
      setIsUnlocked(true);
    }
    setIsChecking(false);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === SITE_PASSWORD) {
      localStorage.setItem(STORAGE_KEY, 'true');
      setIsUnlocked(true);
      setError(false);
    } else {
      setError(true);
    }
  };

  if (isChecking) {
    return null;
  }

  if (isUnlocked) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center p-4">
      <div className="bg-panel border border-line rounded-2xl p-8 shadow-lg max-w-sm w-full">
        <h1 className="font-display text-2xl text-text mb-2 text-center">
          Coming Soon
        </h1>
        <p className="text-text-dim text-sm text-center mb-6">
          This site is currently in private preview.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setError(false);
            }}
            placeholder="Enter password"
            className={`input mb-4 ${error ? 'border-warn' : ''}`}
            autoFocus
          />

          {error && (
            <p className="text-warn text-sm mb-4 text-center">
              Incorrect password
            </p>
          )}

          <button type="submit" className="btn btn-accent w-full">
            Enter
          </button>
        </form>
      </div>
    </div>
  );
}
